/**
 * Small back-to-dashboard breadcrumb shown at the top of every primary
 * module page (Playbook, Academy, Notes, AI Coach, …).
 *
 * Why it exists: on mobile the sidebar is collapsed behind a burger menu,
 * so a player/coach who lands deep in a module needs an obvious way to
 * step back to the hub without hunting for navigation. Mirroring the
 * same affordance on desktop also reinforces hierarchy (page A is INSIDE
 * the dashboard, not parallel to it).
 *
 * Usage:
 *   <BackToDashboard />
 * Optional `to` to route to a different anchor:
 *   <BackToDashboard to="/playbook" labelKey="back_to_playbook" />
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLang } from '@/context/LangContext';

export default function BackToDashboard({
  to = '/dashboard',
  labelKey = 'back_to_dashboard',
  className = '',
  'data-testid': testId,
}) {
  const { t } = useLang();
  return (
    <Link
      to={to}
      data-testid={testId || 'back-to-dashboard'}
      className={`inline-flex items-center gap-1.5 text-gold/70 hover:text-gold text-xs font-mono uppercase tracking-[0.25em] mb-3 ${className}`}
    >
      <ArrowLeft className="w-3.5 h-3.5" /> {t(labelKey)}
    </Link>
  );
}
